
import { Module } from 'vuex';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';
import { TaskRequestState } from './types';
import { RootState } from '../../types';
import { state } from './state';

const namespaced: boolean = true;

export const taskRequestModule: Module<TaskRequestState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};
